import request from '@/utils/request'

/**
 * @apiName 服务商名称模糊查询
 * @param  data - {name:名称}
 */

export function getCompanyProviderLikeByNameApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/likeByName',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 租赁方案名称模糊查询
 * @param  data {name:名称,rentPlanType:租赁方案类型  1 "个人租赁方案"  2 "企业租赁方案",allFlag}
 * @returns
 */
export function getRentPlanNamesApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/likeByName',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 门店名称模糊查询
 * @param  data {name:名称}
 */
export function maintenanceStoreLikeByNameApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/store/likeByName',
    method: 'POST',
    data,
  })
}
